import { render } from "./DatasetList.vue?vue&type=template&id=8ec7cbd8&scoped=true"
import script from "./DatasetList.vue?vue&type=script&lang=js"
export * from "./DatasetList.vue?vue&type=script&lang=js"

import "./DatasetList.vue?vue&type=style&index=0&id=8ec7cbd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec7cbd8"]])

export default __exports__